import { Grid } from '@material-ui/core'
import React from 'react'

export default function BlsGridTitle({children, title, style, width = "15%", noTitle = false}) {
    return (
        <>
            <Grid item xs={12} style={{border: "solid 1px #99bce8", borderTopLeftRadius: "10px", marginTop: "5px", height: "auto", textAlign: "left", ...style}}>
                <Grid item xs={12} style={{height: "25px", textAlign: "center", display: noTitle ? "none" : "block"}}>
                    <Grid className="sectionTitle" style={{width: width, height: "100%", borderRadius: "10px 0px 10px 0px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                        <span className='dark:text-white text-black' >{title}</span>
                    </Grid>
                </Grid>

                {children}
            </Grid>
        </>
    )
}
